export const NGO_USER_LOGIN_REQUEST = 'NGO_USER_LOGIN_REQUEST'
export const NGO_USER_LOGIN_SUCCESS = 'NGO_USER_LOGIN_SUCCESS'
export const NGO_USER_LOGIN_FAIL = 'NGO_USER_LOGIN_FAIL'
export const NGO_USER_LOGOUT = 'NGO_USER_LOGOUT'

export const NGO_USER_REGISTER_REQUEST = 'NGO_USER_REGISTER_REQUEST'
export const NGO_USER_REGISTER_SUCCESS = 'NGO_USER_REGISTER_SUCCESS'
export const NGO_USER_REGISTER_FAIL = 'NGO_USER_REGISTER_FAIL'

export const NGO_USER_DETAILS_REQUEST = 'NGO_USER_DETAILS_REQUEST'
export const NGO_USER_DETAILS_SUCCESS = 'NGO_USER_DETAILS_SUCCESS'
export const NGO_USER_DETAILS_FAIL = 'NGO_USER_DETAILS_FAIL'
export const NGO_USER_DETAILS_RESET = 'NGO_USER_DETAILS_RESET'

export const NGO_USER_UPDATE_PROFILE_REQUEST = 'NGO_USER_UPDATE_PROFILE_REQUEST'
export const NGO_USER_UPDATE_PROFILE_SUCCESS = 'NGO_USER_UPDATE_PROFILE_SUCCESS'
export const NGO_USER_UPDATE_PROFILE_FAIL = 'NGO_USER_UPDATE_PROFILE_FAIL'
export const NGO_USER_UPDATE_PROFILE_RESET = 'NGO_USER_UPDATE_PROFILE_RESET'

export const NGO_USER_LIST_REQUEST = 'NGO_USER_LIST_REQUEST'
export const NGO_USER_LIST_SUCCESS = 'NGO_USER_LIST_SUCCESS'
export const NGO_USER_LIST_FAIL = 'NGO_USER_LIST_FAIL'
export const NGO_USER_LIST_RESET = 'NGO_USER_LIST_RESET'

export const NGO_USER_DELETE_REQUEST = 'NGO_USER_DELETE_REQUEST'
export const NGO_USER_DELETE_SUCCESS = 'NGO_USER_DELETE_SUCCESS'
export const NGO_USER_DELETE_FAIL = 'NGO_USER_DELETE_FAIL'

export const GET_NGO_DETAILS_REQUEST = 'GET_NGO_DETAILS_REQUEST'
export const GET_NGO_DETAILS_SUCCESS = 'GET_NGO_DETAILS_SUCCESS'
export const GET_NGO_DETAILS_FAIL = 'GET_NGO_DETAILS_FAIL'
export const GET_NGO_DETAILS_RESET = 'GET_NGO_DETAILS_RESET'

export const NGO_USER_UPDATE_REQUEST = 'NGO_USER_UPDATE_REQUEST'
export const NGO_USER_UPDATE_SUCCESS = 'NGO_USER_UPDATE_SUCCESS'
export const NGO_USER_UPDATE_FAIL = 'NGO_USER_UPDATE_FAIL'
export const NGO_USER_UPDATE_RESET = 'NGO_USER_UPDATE_RESET'

export const GET_NGO_USER_DONATE_REQUEST = 'GET_NGO_USER_DONATE_REQUEST'
export const GET_NGO_USER_DONATE_SUCCESS = 'GET_NGO_USER_DONATE_SUCCESS'
export const GET_NGO_USER_DONATE_FAIL = 'GET_NGO_USER_DONATE_FAIL'
export const GET_NGO_USER_DONATE_RESET = 'GET_NGO_USER_DONATE_RESET'

export const NGO_CREATE_REVIEW_REQUEST = 'NGO_CREATE_REVIEW_REQUEST'
export const NGO_CREATE_REVIEW_SUCCESS = 'NGO_CREATE_REVIEW_SUCCESS'
export const NGO_CREATE_REVIEW_FAIL = 'NGO_CREATE_REVIEW_FAIL'
export const NGO_CREATE_REVIEW_RESET = 'NGO_CREATE_REVIEW_RESET'
